/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 7538:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
        __webpack_require__(26318), __webpack_require__(54148), __webpack_require__(87190), __webpack_require__(66098), __webpack_require__(53407), __webpack_require__(77116), __webpack_require__(32011),

        __webpack_require__(15862),
        __webpack_require__(23780),
        __webpack_require__(12577),
        __webpack_require__(88041),
        __webpack_require__(78428),
        __webpack_require__(94664),
        __webpack_require__(51354),
        __webpack_require__(71554),
        __webpack_require__(55626),

        __webpack_require__(13568),
        __webpack_require__(13548),
        __webpack_require__(9766),
        __webpack_require__(84195),
        __webpack_require__(12953),
        __webpack_require__(11181),
        __webpack_require__(26707),
        __webpack_require__(99307),
        __webpack_require__(70163),
        __webpack_require__(3120),
        __webpack_require__(1551),
        __webpack_require__(98183),
        __webpack_require__(60745),
        __webpack_require__(45627),
        __webpack_require__(11782),
        __webpack_require__(67272),
        __webpack_require__(79424),
        __webpack_require__(90570),
        __webpack_require__(4810),
        __webpack_require__(28264),

        __webpack_require__(45780),
        __webpack_require__(70624),
        __webpack_require__(25220),
        __webpack_require__(41434),
        __webpack_require__(19986),
        __webpack_require__(25419)
    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
})(function() {

    var __meta__ = {
        id: "editor",
        name: "Editor",
        category: "web",
        description: "Rich text editor component",
        depends: [ "combobox", "dropdownlist", "window", "colorpicker" ],
        features: [ {
            id: "editor-imagebrowser",
            name: "Image Browser",
            description: "Support for uploading and inserting images",
            depends: [ "imagebrowser" ]
        }, {
            id: "editor-resizable",
            name: "Resize handle",
            description: "Support for resizing the content area via a resize handle",
            depends: [ "resizable" ]
        }, {
            id: "editor-tablewizard",
            name: "Table wizard dialog",
            description: "Support for table properties configuration",
            depends: [ "tabstrip", "button", "numerictextbox" ]
        }, {
            id: "editor-pdf-export",
            name: "PDF export",
            description: "Export Editor content as PDF",
            depends: [ "pdf", "drawing" ]
        }]
    };

	return window.kendo;

}, __webpack_require__.amdD);


/***/ }),

/***/ 94664:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/command");

/***/ }),

/***/ 51354:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/components");

/***/ }),

/***/ 12577:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/dom");

/***/ }),

/***/ 55626:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/immutables");

/***/ }),

/***/ 23780:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/main");

/***/ }),

/***/ 67272:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/clipboard");

/***/ }),

/***/ 99307:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/export");

/***/ }),

/***/ 90570:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/exportpdf");

/***/ }),

/***/ 45627:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/file");

/***/ }),

/***/ 1551:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/format");

/***/ }),

/***/ 60745:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/formatblock");

/***/ }),

/***/ 28264:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/formatpainter");

/***/ }),

/***/ 84195:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/formatting");

/***/ }),

/***/ 12953:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/image");

/***/ }),

/***/ 11181:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/import");

/***/ }),

/***/ 70163:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/indent");

/***/ }),

/***/ 98183:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/inlineformat");

/***/ }),

/***/ 26707:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/insert");

/***/ }),

/***/ 79424:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/keyboard");

/***/ }),

/***/ 3120:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/linebreak");

/***/ }),

/***/ 13548:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/link");

/***/ }),

/***/ 9766:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/lists");

/***/ }),

/***/ 4810:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/print");

/***/ }),

/***/ 11782:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/tables");

/***/ }),

/***/ 13568:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/plugins/viewhtml");

/***/ }),

/***/ 78428:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/range");

/***/ }),

/***/ 45780:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/resizing/column-resizing");

/***/ }),

/***/ 41434:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/resizing/element-resize-handle");

/***/ }),

/***/ 25220:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/resizing/element-resizing");

/***/ }),

/***/ 70624:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/resizing/row-resizing");

/***/ }),

/***/ 88041:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/serializer");

/***/ }),

/***/ 19986:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/table-wizard/table-wizard-command");

/***/ }),

/***/ 25419:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/table-wizard/table-wizard-dialog");

/***/ }),

/***/ 71554:
/***/ (function(module) {

"use strict";
module.exports = require("./editor/toolbar");

/***/ }),

/***/ 53407:
/***/ (function(module) {

"use strict";
module.exports = require("./kendo.colorpicker");

/***/ }),

/***/ 26318:
/***/ (function(module) {

"use strict";
module.exports = require("./kendo.combobox");

/***/ }),

/***/ 54148:
/***/ (function(module) {

"use strict";
module.exports = require("./kendo.dropdownlist");

/***/ }),

/***/ 77116:
/***/ (function(module) {

"use strict";
module.exports = require("./kendo.imagebrowser");

/***/ }),

/***/ 32011:
/***/ (function(module) {

"use strict";
module.exports = require("./kendo.numerictextbox");

/***/ }),

/***/ 87190:
/***/ (function(module) {

"use strict";
module.exports = require("./kendo.resizable");

/***/ }),

/***/ 66098:
/***/ (function(module) {

"use strict";
module.exports = require("./kendo.window");

/***/ }),

/***/ 15862:
/***/ (function(module) {

"use strict";
module.exports = require("./util/undoredostack");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd define */
/******/ 	!function() {
/******/ 		__webpack_require__.amdD = function () {
/******/ 			throw new Error('define cannot be used indirect');
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(7538);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;